export function spendingDemandRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SPENDING_DEMAND_START":           
        case "UPDATE_SPENDING_DEMAND_START":           
        case "FETCH_ADMIN_SPENDING_DEMANDS_START":                                 
        case "FETCH_USER_SPENDING_DEMANDS_START":                                 
        case "FETCH_SPENDING_DEMAND_PAYMENTS_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SPENDING_DEMAND_FULFILLED":           
        case "UPDATE_SPENDING_DEMAND_FULFILLED":           
        case "FETCH_ADMIN_SPENDING_DEMANDS_FULFILLED":                                 
        case "FETCH_USER_SPENDING_DEMANDS_FULFILLED":                                 
        case "FETCH_SPENDING_DEMAND_PAYMENTS_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SPENDING_DEMAND_ERROR":
        case "UPDATE_SPENDING_DEMAND_ERROR":
        case "FETCH_ADMIN_SPENDING_DEMANDS_ERROR":
        case "FETCH_USER_SPENDING_DEMANDS_ERROR":
        case "FETCH_SPENDING_DEMAND_PAYMENTS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}